import { useMainStore } from '@/features/common/stores';
import { injectable } from 'inversify';
import { ax } from '@/plugins/axios';
import { isAxiosError } from 'axios';

@injectable()
export class ApiService {
    _mainStore: ReturnType<typeof useMainStore>;

    async httpGet<T>(url: string, data?: any, timeout?: number): Promise<T | undefined> {
        try {
            const response = await ax.get<T>(url, { ...data, timeout });
            return response.data;
        } catch (error) {
            //todo: commented lines cause a infinite page reload - need to check if with BFF we still need redirect for API calls
            // if (this.handleAuthError(error)) {
            //     return;
            // }

            this.mainStore.registerError(error);
            throw error;
        }
    }

    async httpPost<T>(url: string, data?: any): Promise<T> {
        try {
            const response = await ax.post<T>(url, data);
            return response.data;
        } catch (error) {
            this.mainStore.registerError(error);
            throw error;
        }
    }

    async httpPut<T>(url: string, data?: any): Promise<T> {
        try {
            const response = await ax.put<T>(url, data);
            return response.data;
        } catch (error) {
            this.mainStore.registerError(error);
            throw error;
        }
    }

    async httpDelete<T>(url: string): Promise<T> {
        try {
            const response = await ax.delete<T>(url);
            return response.data;
        } catch (error) {
            this.mainStore.registerError(error);
            throw error;
        }
    }

    get mainStore(): ReturnType<typeof useMainStore> {
        if (!this._mainStore) {
            this._mainStore = useMainStore();
        }

        return this._mainStore;
    }

    handleAuthError(e: unknown): boolean {
        if (isAxiosError(e) && (e.response?.status === 401 || e.response?.status === 403)) {
            window.location.href = `/Authenticate/?returnUrl=${encodeURI(window.location.href)}`;

            return true;
        }

        return false;
    }
}
